import { Code } from '../../../proto/out/google/rpc/code';
import { modalType } from '../../../config/Enum/AlertModal';
import { handleAlertModal } from '../handleAlertModal';
import getCookie from '../getCookie';

const runOkResponse = (okResponse) => {
  if (typeof okResponse === 'function') {
    return okResponse();
  }
  return okResponse;
};

export const getApiResponse = ({ responseValue, dispatch, okResponse, onError = undefined }) => {
  if (Code[responseValue.responseContext.status.code] === 'OK') {
    return runOkResponse(okResponse);
  }
  if (typeof onError === 'function' && onError(responseValue)) {
    return;
  }
  if (Code[responseValue.responseContext.status.code] === 'FAILED_PRECONDITION') {
    if (
      // this for cancel button information page
      responseValue.responseContext.status.message === 'OK' &&
      getCookie('nextStepURI') === '/api/car/info'
    ) {
      return runOkResponse(okResponse);
    } else if (
      // this for cancel button information page
      responseValue.responseContext.status.message === 'OK' &&
      getCookie('nextStepURI') === '/api/business-license/info'
    ) {
      return runOkResponse(okResponse);
    } else {
      handleAlertModal({
        dispatch,
        modalType: modalType.ALERT,
        modalDescription: responseValue.responseContext.status.message,
        modalButtonUrl: 'refreshPage'
      });
    }
  } else if (
    Code[responseValue.responseContext.status.code] === 'RESOURCE_EXHAUSTED' ||
    Code[responseValue.responseContext.status.code] === 'INVALID_ARGUMENT'
  ) {
    handleAlertModal({
      dispatch,
      modalType: modalType.ALERT,
      modalDescription: responseValue.responseContext.status.message,
      modalButtonUrl: 'cancelledFlow'
    });
  } else
    handleAlertModal({
      dispatch,
      modalType: modalType.ALERT,
      modalDescription: responseValue.responseContext.status.message,
      modalButtonUrl: 'businessReturnUrl'
    });
};
